// extracted by mini-css-extract-plugin
module.exports = {"notification_container":"_2gc6T","notification":"_1e2t6"};